import React, { Component, Fragment } from 'react';

const Tooltip = ({ content }) => {
    return (
        <div className="data_tooltip" tooltip={ content }>
            <span className='text_ellipsis'>{ content }</span>
        </div>
    );
}

export default Tooltip;